import React from "react";
import { Link } from "react-router-dom";

const campaigns = [
  {
    id: 1,
    title: "Cancer Awareness",
    description:
      "We reduce cancer's impact with free screenings and educational workshops. Patients and families receive essential support and resources.",
    image:
      "https://images.unsplash.com/photo-1576089172869-4f5f6f315620?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=600",
  },
  {
    id: 2,
    title: "Clean India",
    description:
      "We enhance rural sanitation through community clean-up drives and building facilities. Education on waste management ensures cleaner, healthier environments.",
    image: "/clean.avif",
  },
  {
    id: 3,
    title: "Skill Development",
    description:
      "We provide vocational training and workshops, empowering women and youth to achieve financial independence and better lives.",
    image:
      "https://images.unsplash.com/photo-1593526613712-7b4b9a707330?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=600",
  },
  {
    id: 4,
    title: "Rural Education",
    description:
      "We improve education in remote areas by supporting schools, providing learning materials, and training teachers for quality education.",
    image:
      "https://images.unsplash.com/photo-1522661067900-ab829854a57f?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=600",
  },
];

const CampaignCards: React.FC = () => {
  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h6 className="text-primary font-semibold mb-2">Campaigns</h6>
          <h2 className="text-3xl md:text-4xl font-bold text-dark">
            Explore Our Causes
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {campaigns.map((campaign) => (
            <div
              key={campaign.id}
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
            >
              <img
                src={campaign.image}
                alt={campaign.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3 text-dark">
                  {campaign.title}
                </h3>
                <p className="text-gray-600 mb-4">{campaign.description}</p>
                <Link
                  to={`/donate?campaign=${campaign.id}`}
                  className="btn-primary inline-block w-full text-center"
                >
                  Donate Now
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CampaignCards;
